module.exports = __webpack_public_path__ + "static/media/res12.f172317b.PNG";